var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XLogo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.133 20.3239L14.2643 11.1008L20.0552 4.73045C20.1862 4.58282 20.2537 4.38951 20.2431 4.19244C20.2325 3.99537 20.1446 3.81042 19.9986 3.67769C19.8525 3.54496 19.66 3.47514 19.4628 3.48338C19.2657 3.49162 19.0797 3.57725 18.9452 3.7217L13.4289 9.7892L9.633 3.82389C9.56531 3.71734 9.47183 3.62961 9.36121 3.56881C9.25059 3.50801 9.12642 3.47611 9.00019 3.47607H4.50019C4.36571 3.47601 4.2337 3.5121 4.11796 3.58057C4.00222 3.64904 3.90702 3.74736 3.84232 3.86525C3.77763 3.98314 3.74582 4.11625 3.75023 4.25066C3.75463 4.38506 3.7951 4.5158 3.86738 4.6292L9.73613 13.8514L3.94519 20.2264C3.87756 20.299 3.82503 20.3844 3.79063 20.4775C3.75623 20.5706 3.74065 20.6696 3.74479 20.7687C3.74894 20.8679 3.77272 20.9652 3.81477 21.0551C3.85681 21.145 3.91628 21.2257 3.98973 21.2925C4.06318 21.3592 4.14915 21.4107 4.24265 21.444C4.33615 21.4773 4.43533 21.4917 4.53443 21.4863C4.63354 21.481 4.7306 21.4561 4.81999 21.4129C4.90938 21.3698 4.98932 21.3094 5.05519 21.2351L10.5714 15.1676L14.3674 21.1329C14.4356 21.2386 14.5293 21.3254 14.6399 21.3854C14.7505 21.4454 14.8744 21.4765 15.0002 21.4761H19.5002C19.6345 21.476 19.7664 21.4399 19.882 21.3715C19.9976 21.3031 20.0927 21.2049 20.1573 21.0871C20.222 20.9694 20.2539 20.8364 20.2496 20.7022C20.2453 20.5679 20.205 20.4373 20.133 20.3239ZM15.4118 19.9761L5.86613 4.97607H8.58488L18.1343 19.9761H15.4118Z",
    fill: "#65636A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXLogo);
export default __webpack_public_path__ + "static/media/XLogo.a73e1a6f6df26b94a6e5f0df62dcfcb4.svg";
export { ForwardRef as ReactComponent };